import React, { ReactElement } from 'react';
import Button from 'atomic/utilization/button';

import './carousel-multi-button-group.scss';

const CarouselMultiButtonGroup = ({ next, previous, ...rest }: any): ReactElement => {
    const { carouselState: { currentSlide, totalItems, slidesToShow } } = rest;

    return (
        <div className="carousel-button-group">
            {currentSlide !== 0 && (
                <Button type="button" className="carousel-button-group-prev" onClick={previous}
                    ariaLabel="Poprzednia strona"
                >
                    <i className="icon-arr2-left"/>
                </Button>
            )}
            {currentSlide !== (totalItems - slidesToShow) && (
                <Button type="button" className="carousel-button-group-next" onClick={next}
                    ariaLabel="Następna strona"
                >
                    <i className="icon-arr2-right"/>
                </Button>
            )}
        </div>
    );
};

export default CarouselMultiButtonGroup;
